<template>
  <div
    style="
      overflow: hidden;
      height: 100%;
      background-color: #f6f6f6;
      display: flex;
      flex-direction: column;
    "
  >
    <van-nav-bar
      left-text="返回"
      left-arrow
      van-nav-bar
      safe-area-inset-top
      @click-left="onBack"
    >
      <template #title>
        {{ $store.state.loginUser?.name }}
        <text v-if="$store.state.loginUser?.department_name">{{
          "/" + $store.state.loginUser?.department_name
        }}</text>
      </template>
    </van-nav-bar>
    <div
      style="
        height: 100%;
        padding: 10px;
        display: flex;
        flex-direction: column;
        overflow-y: auto;
      "
    >
      <div style="flex: 1">
        <van-pull-refresh v-model="state.isRefresh" @refresh="onRefresh">
          <ul style="font-weight: 600; font-size: 14px; margin-top: 10px">
            工资表信息
          </ul>
          <div
            style="
              background-color: #fff;
              border-radius: 10px;
              padding: 10px;
              position: relative;
              font-size: 13px;
              margin-top: 10px;
            "
          >
            <ul
              style="
                text-align: center;
                font-weight: 600;
                padding-bottom: 10px;
                border-bottom: 1px solid #e2e2e2;
              "
            >
              {{
                state.model?.payroll?.name
              }}
            </ul>
            <ul style="display: flex; align-items: center; line-height: 30px">
              <li style="flex: 1; color: #a2a2a2">单号</li>
              {{
                state.model?.payroll?.order_id
              }}
            </ul>
            <ul style="display: flex; align-items: center; line-height: 30px">
              <li style="flex: 1; color: #a2a2a2">总人数</li>
              {{
                $numberFormat(state.model?.payroll?.employee_num)
              }}
            </ul>
            <ul style="display: flex; align-items: center; line-height: 30px">
              <li style="flex: 1; color: #a2a2a2">总金额</li>
              {{
                $priceFormat(state.model?.payroll?.settle_amount)
              }}
            </ul>
            <ul style="display: flex; align-items: center; line-height: 30px">
              <li style="flex: 1; color: #a2a2a2">已收款</li>
              {{
                $priceFormat(state.model?.payroll?.receipt_amount)
              }}
            </ul>
            <ul style="display: flex; align-items: center; line-height: 30px">
              <li style="flex: 1; color: #a2a2a2">未收款</li>
              {{
                $priceFormat(state.model?.payroll?.arrearage_amount)
              }}
            </ul>
            <ul style="display: flex; align-items: center; line-height: 30px">
              <li style="flex: 1; color: #a2a2a2">已发放</li>
              {{
                $priceFormat(state.model?.payroll?.paied_amount)
              }}
            </ul>
            <ul style="display: flex; align-items: center; line-height: 30px">
              <li style="flex: 1; color: #a2a2a2">未发放</li>
              {{
                $priceFormat(state.model?.payroll?.unpaied_amount)
              }}
            </ul>
            <ul style="display: flex; align-items: center; line-height: 30px">
              <li style="flex: 1; color: #a2a2a2">应支付供应商总金额</li>
              {{
                $priceFormat(state.model?.payroll?.payable_supplier_amount)
              }}
            </ul>
          </div>
          <ul style="font-weight: 600; font-size: 14px; margin-top: 10px">
            申请单信息
          </ul>
          <div
            style="
              background-color: #fff;
              border-radius: 10px;
              padding: 10px;
              position: relative;
              font-size: 13px;
              margin-top: 10px;
            "
          >
            <ul
              style="
                text-align: center;
                font-weight: 600;
                padding-bottom: 10px;
                border-bottom: 1px solid #e2e2e2;
              "
            >
              {{
                state.model.name
              }}
            </ul>
            <ul style="display: flex; align-items: center; line-height: 30px">
              <li style="flex: 1; color: #a2a2a2">状态</li>
              <li style="text-align: right; flex: 1">
                <c_status
                  v-if="state.model.id"
                  arrName="salaryapply_step"
                  :value="state.model.c_step"
                  link
                  :size="14"
                />
              </li>
            </ul>
            <ul style="display: flex; align-items: center; line-height: 30px">
              <li style="flex: 1; color: #a2a2a2">申请单号</li>
              {{
                state.model.order_id
              }}
            </ul>
            <ul style="display: flex; align-items: center; line-height: 30px">
              <li style="flex: 1; color: #a2a2a2">所属客户</li>
              {{
                state.model.customer_name
              }}
            </ul>
            <ul style="display: flex; align-items: center; line-height: 30px">
              <li style="flex: 1; color: #a2a2a2">薪资所属期</li>
              {{
                state.model.month
              }}
            </ul>
            <ul style="display: flex; align-items: center; line-height: 30px">
              <li style="flex: 1; color: #a2a2a2">税款所属期</li>
              {{
                state.model.tax_month
              }}
            </ul>
            <ul style="display: flex; align-items: center; line-height: 30px">
              <li style="flex: 1; color: #a2a2a2">报税类型</li>
              {{
                state.model.d_tax_type_name
              }}
            </ul>
            <ul style="display: flex; align-items: center; line-height: 30px">
              <li style="flex: 1; color: #a2a2a2">约定发薪日期</li>
              {{
                state.model.pay_date
              }}
            </ul>
            <ul style="display: flex; align-items: center; line-height: 30px">
              <li style="flex: 1; color: #a2a2a2">本次发放人数</li>
              {{
                $numberFormat(state.model.employee_num)
              }}
            </ul>
            <ul style="display: flex; align-items: center; line-height: 30px">
              <li style="flex: 1; color: #a2a2a2">本次发放金额</li>
              <c_money :value="state.model.money" bold />
            </ul>
            <ul style="display: flex; align-items: center; line-height: 30px">
              <li style="flex: 1; color: #a2a2a2">申请人</li>
              {{
                state.model.add_admin_name
              }}
              <text v-if="state.model.add_department_name">{{
                "/" + state.model.add_department_name
              }}</text>
            </ul>
            <ul style="display: flex; align-items: center; line-height: 30px">
              <li style="flex: 1; color: #a2a2a2">是否补发</li>
              {{
                state.model?.is_again_pay ? "是" : "否"
              }}
            </ul>
          </div>
          <template v-if="state.log?.length > 0">
            <ul style="font-weight: 600; font-size: 14px; margin-top: 10px">
              审批信息
            </ul>
            <div
              style="
                background-color: #fff;
                border-radius: 10px;
                padding: 10px;
                position: relative;
                font-size: 13px;
                margin: 10px 0;
              "
            >
              <div
                style="
                  line-height: 20px;
                  border-bottom: 1px solid #e2e2e2;
                  padding: 10px 0;
                "
                v-for="item in state.log"
                :key="item"
              >
                <ul style="display: flex">
                  <li style="flex: 1">
                    <c_status
                      arrName="salaryapply_type"
                      :value="item.type"
                      link
                      :size="14"
                    />
                  </li>
                  <text
                    v-if="item.status == 1"
                    style="color: #080; margin-left: 10px"
                  >
                    通过
                  </text>
                  <text v-else style="color: #f00; margin-left: 10px"
                    >不通过</text
                  >
                </ul>
                <ul
                  style="
                    display: flex;
                    align-items: center;
                    width: 100%;
                    color: #a2a2a2;
                  "
                >
                  <li
                    style="
                      flex: 1;
                      margin-right: 40px;
                      overflow: hidden;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                    "
                  >
                    {{ item.add_admin_name }}
                    <text v-if="item.add_department_name">{{
                      "/" + item.add_department_name
                    }}</text>
                  </li>
                  <text>{{ item.create_time }}</text>
                </ul>
              </div>
            </div>
          </template>
        </van-pull-refresh>
      </div>
      <ul style="font-weight: 600; font-size: 14px">
        审批操作
      </ul>
      <div
        style="
          background-color: #fff;
          border-radius: 10px;
          padding: 10px;
          position: relative;
          font-size: 13px;
          margin-top: 10px;
        "
      >
        <van-field
          v-model="state.message"
          rows="2"
          autosize
          type="textarea"
          maxlength="50"
          placeholder="请输入留言"
          style="border: 1px solid #e2e2e2; border-radius: 5px"
        />
        <ul style="display: flex; align-items: center; margin-top: 10px">
          <van-button type="danger" style="flex: 1" @click="onSubmit(2)"
            >不通过</van-button
          >
          <van-button
            type="primary"
            @click="onSubmit(1)"
            style="flex: 1; margin-left: 20px"
          >
            审批通过
          </van-button>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { onBeforeUnmount, onMounted, reactive } from "vue";
import { detail, check } from "@/http/api";
import { showConfirmDialog, showNotify } from "vant";
export default {
  props: {
    id: Number,
  },
  setup(props, { emit }) {
    const state = reactive({
      model: {},
    });
    onMounted(() => {
      if (window.history && window.history.pushState) {
        history.pushState(null, null, document.URL);
        window.addEventListener("popstate", onBack, false);
      }

      onLoad();
    });

    const onLoad = () => {
      detail(props.id).then((res) => {
        state.isRefresh = false;
        if (res.status == 200) {
          const { info, log } = res.data.data;
          state.model = info;
          if (state.model.step == 2) {
            if (state.model.is_arrearage == 1) {
              state.model.c_step = "2-1";
            } else {
              state.model.c_step = "2-2";
            }
          } else {
            state.model.c_step = state.model.step;
          }
          state.log = log;
        }
      });
    };

    const onRefresh = () => {
      state.isRefresh = true;
      onLoad();
    };

    const onBack = () => {
      emit("close", state.refList);
    };

    onBeforeUnmount(() => {
      // 在组件销毁前移除事件监听
      window.removeEventListener("popstate", onBack);
    });

    const onSubmit = (status) => {
      if (status == 2 && !state.message) {
        showNotify({ type: "warning", message: "请填写审核意见" });
        return false;
      }

      showConfirmDialog({
        title: "发薪审核",
        message: `您确定<strong style='color:${
          status === 1 ? "#080" : "#f00"
        }'>${status === 1 ? "同意" : "拒绝"}</strong>该条发薪申请？`,
        allowHtml: true,
      }).then(() => {
        const data = {
          id: props.id,
          status,
          msg: state.message,
        };
        check(data).then((res) => {
          if (res.status == 200) {
            showNotify({ type: "success", message: res.data.data?.msg });
            state.refList = true;
            setTimeout(() => {
              onBack();
            }, 300);
          }
        });
      });
    };

    return { state, onLoad, onRefresh, onBack, onSubmit };
  },
};
</script>
<style scoped></style>
